import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string;
  trend: string;
  trendUp: boolean;
  icon: React.ReactNode;
  delay?: number;
}
export function StatCard({
  title,
  value,
  trend,
  trendUp,
  icon,
  delay = 0
}: StatCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -4
  }} className="bg-white p-6 rounded-2xl border border-rose-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-449">
      <div className="flex justify-between items-start mb-4" data-id="element-450">
        <div className="p-3 bg-rose-50 rounded-xl text-rose-500" data-id="element-451">{icon}</div>
        <div className={`flex items-center space-x-1 text-sm font-medium ${trendUp ? 'text-emerald-500' : 'text-rose-500'}`} data-id="element-452">
          <span data-id="element-453">{trend}</span>
          {trendUp ? <ArrowUpRight size={16} data-id="element-454" /> : <ArrowDownRight size={16} data-id="element-455" />}
        </div>
      </div>

      <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-456">{title}</h3>
      <div className="text-2xl font-bold text-gray-900 font-serif" data-id="element-457">{value}</div>
    </motion.div>;
}